import { createFileRoute } from "@tanstack/react-router";
import { RouteGuard } from "@/components/RouteGuard";
import { ReceiptManagement } from "@/lib/lazyPages";

export const Route = createFileRoute("/admin/receipts")({
  component: () => (
    <RouteGuard access={{ kind: "admin" }}>
      <ReceiptManagement />
    </RouteGuard>
  ),
});
